<template>
  <div class="image-upload-box">
    <div class="image-upload-wrap">
      <el-image
        :src="uploadImage||imageUrl"
        :preview-src-list="uploadImage||imageUrl ? [uploadImage||realImageUrl] : []"
        style="width:200px;height:200px;"
      >
        <div slot="placeholder" class="image-slot">
          加载中<span class="dot">...</span>
        </div>
      </el-image>

      <el-upload
        class=""
        :action="actionUri"
        :show-file-list="false"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :data="{responseType: 'json'}"
        :file-list="uploadFileList"
        name="image"
      >
        <el-button size="mini" type="primary" class="image-upload-button">点此上传</el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
  import Constant from '../utils/constant'
  import FormBuildComponent from "./FormBuild";
  import {getFileUrl, getImageUrl} from "../filters/CommonActions";

  export default {
    name: "ImageUpload",
    components: {FormBuildComponent},
    data() {
      return {
        uploadFileList: [],
        uploadImage: '',
        dialogVisible: false,
      }
    },
    props: {
      field: String,
      value: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'img'
      },
      prefix: {
        type: String,
        default: ''
      },
      maxFileSize: {
        type: Number,
        default: 10
      }
    },
    computed: {
      actionUri: function () {
        return Constant.SERVER_BASE_URL + '/u' + this.type + '/scf.upload'
      },
      imageUrl: function () {
        return this.value && this.value.indexOf('images/')!== -1 ? getImageUrl(this.value, '300x300') : getFileUrl(this.value, '300x300')
      },
      realImageUrl() {
        return this.value && this.value.indexOf('images/')!== -1 ? getImageUrl(this.value) : getFileUrl(this.value)
      }
    },
    methods: {
      handleSuccess(res, file) {
        this.uploadImage = URL.createObjectURL(file.raw);
        this.$emit('input', this.prefix + res.images.reduce((total, image) => {
          total.push(res.albumId + '/' + image.imageId)
          return total
        }, []).shift())
      },
      beforeUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLimitFileSize = file.size / 1024 / 1024 < this.maxFileSize;

        if (!isJPG && !isPNG) {
          this.$message.error('上传图片只能是 JPG 或者 PNG 格式!');
        }
        if (!isLimitFileSize) {
          this.$message.error('上传图片大小不能超过 ' + this.maxFileSize + 'MB!');
        }
        return (isJPG || isPNG) && isLimitFileSize;
      }
    }
  }
</script>

<style scoped>
  .image-upload-box {

  }
  .image-upload-box .image-upload-wrap {
    width: 100%;
/*    border: 1px dashed #d9d9d9;*/
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .image-upload-wrap .el-upload {
/*    border: 1px dashed #d9d9d9;*/
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .image-upload-wrap .el-upload:hover {
    border-color: #409EFF;
  }
  .image-upload-wrap-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
/*    height: 178px;*/
    line-height: 178px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/ImageUpload.vue